import Dict from './messages';
import * as glb from "./globals";
import { appendSsHandoffMenu } from './utils/ssHandoffMenu';

export function navigation() {

    // Guard against missing EKRANLkp (e.g., before login)
    const screens = Array.isArray(glb.default.EKRANLkp) ? glb.default.EKRANLkp : [];
    const items = [];
    const itemsById = new Map();
    for (let i = 0; i < screens.length; i++) {
      if (screens[i].EKR_ISBAR === true) continue; 
      let screen = Dict.get(screens[i].EKR_ETIKET);
      if (!screen) screen = screens[i].EKR_ETIKET || '';
      // Leaf'lerde items:[] vermeyin — DevExtreme boş diziyle tıklamayı yutabiliyor.
      const item = {
        text: screen,
        path: '/' + screens[i].EKR_EKRANADI,
        icon: screens[i].EKR_ICON,
        id: screens[i].EKR_REF,
        parentid: screens[i].EKR_UST_REF,
      };
      items.push(item);
      itemsById.set(item.id, item);
    }

    // Parent ve child kayitlarin sorgu sonucunda art arda gelmesi gerekmez.
    const result = [];
    for (const item of items) {
      const parent = itemsById.get(item.parentid);
      if (parent && parent !== item) {
        if (!Array.isArray(parent.items)) parent.items = [];
        parent.items.push(item);
      } else {
        result.push(item);
      }
    }
    const legacyParent = result.find(item => item.text === 'Eski CRM');
    const legacyChild = { text: 'Cari Kart', path: '/LEGACY_CARI_DFM', icon: 'card', id: 'legacy-cari-dfm-menu' };
    if (legacyParent) {
      if (!legacyParent.items?.some(item => item.path === legacyChild.path)) legacyParent.items = [...(legacyParent.items || []), legacyChild];
    } else {
      result.push({ text: 'Eski CRM', icon: 'folder', id: 'legacy-crm-menu', items: [legacyChild] });
    }
    return appendSsHandoffMenu(result, {
      user: glb.default.KULLANICI,
      firms: glb.default.FIRMALkp,
    });
}
